import ButtonModel, { PageButtonConfig } from '@mm/state/model/ButtonModel';
import { UploadImgModel } from '@mm/state/model/UploadImgModel';
import WidgetModel from '@mm/state/model/WidgetModel';
import { ReactComponent as CloseIcon } from 'assets/close-icon.svg';
import { ReactComponent as ImageIcon } from 'assets/image-icon.svg';
import React, { MouseEvent } from 'react';
import ImageUpload from '../../../../../components/ImageUpload/ImageUpload';
import { useQQWidgetHandlers } from '../../../../../helpers/widget-helpers/use-qq-widget-handlers';

type Props = {
  quickQuestion: WidgetModel;
  button: ButtonModel;
};

export const QuestionButtonImageUpload = (props: Props) => {
  const { quickQuestion, button } = props;
  const qqWidgetHandlers = useQQWidgetHandlers();
  const imageUrl = (button.config as PageButtonConfig).file;

  const uploadImage = (imgBase64: UploadImgModel) => {
    qqWidgetHandlers.addImageToPostBackButton(
      quickQuestion,
      button.id,
      imgBase64,
    );
  };

  return (
    <div className="question-button__image-upload-container">
      <ImageUpload
        title="Upload icon"
        imgUrl={imageUrl}
        uploadImage={uploadImage as any}
        removeImage={() =>
          qqWidgetHandlers.removeImageFromPostBackButton(
            quickQuestion,
            button.id,
          )
        }
        couldBeRemoved
        onRatioChange={() => {}}
        iconSize={1}
        showLoader={true}
        iconArea={(onUpload: (e?: MouseEvent<HTMLDivElement>) => any) => (
          <>
            <div className="question-button__upload-icon-area">
              {imageUrl && (
                <img
                  alt="Uploaded Asset"
                  src={imageUrl}
                  className="question-button__upload-icon-area-image"
                />
              )}

              {!imageUrl && (
                <div
                  onClick={onUpload}
                  className="question-button__add-image-wrapper"
                >
                  <ImageIcon className="question-button__add-image-icon" />
                </div>
              )}
            </div>

            {imageUrl && (
              <div
                onClick={() =>
                  qqWidgetHandlers.removeImageFromPostBackButton(
                    quickQuestion,
                    button.id,
                  )
                }
                className="question-button__remove-image-icon"
              >
                <CloseIcon />
              </div>
            )}

            {!imageUrl && (
              <div
                className="question-button__add-image-icon-plus"
                onClick={onUpload}
              >
                +
              </div>
            )}
          </>
        )}
      />
    </div>
  );
};
